/**
 * Reports whose server-side generator is currently switched off, keyed by slug.
 *
 * `reportConfigs.ts` already owns this fact as `DISABLED_REPORT_FKEYS`, keyed
 * by `fKey_RS_Report`. That file is ~675 KB, so anything in the always-loaded
 * bundle (the command palette, for one) cannot import it just to ask whether
 * a slug is runnable. Hence this module: the same fact, keyed by slug, small
 * enough to import anywhere.
 *
 * `disabledReports.sync.test.ts` fails the build if the two lists disagree, so
 * this cannot quietly drift out of date.
 *
 * Empty today. It last held the five grid reports (resident-data-grid,
 * weights, aim-selective-menu-changes, meal-pattern-aim-changes,
 * item-linking-data-grid); web prints of those now go to the Linux renderer.
 * To switch a report off again, add it to BOTH lists.
 */
export const DISABLED_REPORT_SLUGS: ReadonlySet<string> = new Set<string>([]);

/** True when this report cannot currently be run from the web client. */
export function isSlugDisabled(slug: string): boolean {
  return DISABLED_REPORT_SLUGS.has(slug);
}
